<template>
  <tr>
    <td class="labeltext">{{label}}</td>
    <td><CalloutValue :text="percentageYieldValue" :bpsChange="bpsChangeValue"/></td>
    <td>{{bpsChangeValue}}</td>
    <td>{{percentageChangeValue}}</td>
  </tr>
</template>

<script>
  import * as data from '../../../client/src/data.js';
  import CalloutValue from './CalloutValue';
  export default {
    components: {CalloutValue},
    data() {
      return {
        data: data
      }
    },
    props: {
      label: {
        required: true
      },
      bpsChange: {
        required: true
      },
      percentageYield: {
        required: true
      },
      percentageChange: {
        required: true
      }
    },
    computed: {
      percentageYieldValue() {
        return data.isNumber(this.percentageYield) ? this.percentageYield.toFixed(2) + '%' : 'N/A';
      },
      bpsChangeValue() {
        return data.isNumber(this.bpsChange) ? (this.bpsChange * 100).toFixed(0) : 'N/A';
      },
      percentageChangeValue() {
        return data.isNumber(this.percentageChange) ? this.percentageChange.toFixed(2) + '%' : 'N/A';
      },
      bpsCallout() {
        return this.yieldsForDate && data.isNumber(this.bpsChange) ? (this.bpsChange * 100).toFixed(0) : '';
      },
    }
  }
</script>

